export interface VirtualLayer {
  level: number,
  layerName: string,
  name: string,
  defaultSelected: boolean
  tiled: boolean,
  minZoom: number,
}

export const LAYER_KEY_NAME = {
  ADS_B: 'ADS-B',
};

export const virtualLayers : VirtualLayer[] = [
  {
    level: 0,
    layerName: LAYER_KEY_NAME.ADS_B,
    name: LAYER_KEY_NAME.ADS_B,
    defaultSelected: true,
    tiled: false,
    minZoom: 3,
  },
];
